import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv, formatCurrency, formatPercent } from '@/components/relatorios/reportUtils'
import { useSellerSalesReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function VendasVendedorReport() {
  const [range, setRange] = useReportDateRange()
  const report = useSellerSalesReport(range)
  const totalWon = report.data.reduce((sum, row) => sum + row.won, 0)
  const totalRevenue = report.data.reduce((sum, row) => sum + row.revenue, 0)

  return (
    <ReportShell
      title="Vendas por vendedor"
      description="Aquisição, oportunidades e fechamento por responsável."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={!report.data.some((row) => row.leads + row.opportunities + row.won + row.lost > 0)}
      onRetry={report.refetch}
      onExport={() => exportCsv('vendas-vendedor', report.data, [
        { label: 'Vendedor', value: (row) => row.seller },
        { label: 'Leads', value: (row) => row.leads },
        { label: 'Oportunidades', value: (row) => row.opportunities },
        { label: 'Ganhas', value: (row) => row.won },
        { label: 'Perdidas', value: (row) => row.lost },
        { label: 'Receita', value: (row) => row.revenue.toFixed(2).replace('.', ',') },
        { label: 'Ticket médio', value: (row) => row.averageTicket.toFixed(2).replace('.', ',') },
        { label: 'Conversão (%)', value: (row) => row.conversion.toFixed(1).replace('.', ',') },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Vendas ganhas" value={totalWon} />
        <ReportKpiCard label="Receita" value={formatCurrency(totalRevenue)} />
        <ReportKpiCard label="Ticket médio geral" value={formatCurrency(totalWon ? totalRevenue / totalWon : 0)} />
      </div>
      <ReportChart
        type="bar"
        data={report.data.map((row) => ({ ...row }))}
        xKey="seller"
        series={[
          { key: 'won', label: 'Ganhas', color: 'var(--chart-2)' },
          { key: 'lost', label: 'Perdidas', color: 'var(--chart-5)' },
        ]}
      />
      <ReportTable
        rows={report.data}
        rowKey={(row) => row.sellerId}
        columns={[
          { key: 'seller', label: 'Vendedor', render: (row) => <span>{row.seller}{!row.active && <small className="ml-2 text-muted-foreground">(inativo)</small>}</span> },
          { key: 'leads', label: 'Leads', align: 'right', render: (row) => row.leads },
          { key: 'opportunities', label: 'Oportunidades', align: 'right', render: (row) => row.opportunities },
          { key: 'won', label: 'Ganhas', align: 'right', render: (row) => row.won },
          { key: 'lost', label: 'Perdidas', align: 'right', render: (row) => row.lost },
          { key: 'revenue', label: 'Receita', align: 'right', render: (row) => formatCurrency(row.revenue) },
          { key: 'ticket', label: 'Ticket médio', align: 'right', render: (row) => formatCurrency(row.averageTicket) },
          { key: 'conversion', label: 'Conversão', align: 'right', render: (row) => formatPercent(row.conversion) },
        ]}
      />
    </ReportShell>
  )
}
